export const ADD = 'ADD_ACTION';
export const UPDATE = 'UPDATE_ACTION'; 
export const REMOVE = 'REMOVE_ACTION';
export const SET = 'SET_ACTIONS';
